export default "__VITE_ASSET__mpQibiw$__"